import { useSettingBatch10TopNavSignupCTA } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingBatch10TopNavSignupCTA";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";
import { useStrictLocalization } from "@faire/web/common/localization";

export const useHeaderSignUpCopy = () => {
  const { strictLocalize } = useStrictLocalization();
  const settingBatch10TopNavSignupCTA = useSettingBatch10TopNavSignupCTA();

  switch (settingBatch10TopNavSignupCTA) {
    case IFourVariantXP.Bucket.CONTROL:
      return strictLocalize({
        id: "e13Mfi",
        defaultMessage: "Sign up",
        description: { text: "CTA button to sign up" },
      });
    case IFourVariantXP.Bucket.VARIANT_2:
      return strictLocalize({
        id: "Y9NaS1",
        defaultMessage: "Sign up for free",
        description: { text: "CTA button to sign up" },
      });
    case IFourVariantXP.Bucket.VARIANT_3:
      return strictLocalize({
        id: "vMbv5T",
        defaultMessage: "Create free account",
        description: { text: "CTA button to sign up" },
      });
    case IFourVariantXP.Bucket.VARIANT_4:
      return strictLocalize({
        id: "coXYHH",
        defaultMessage: "Join free",
        description: { text: "CTA button to sign up" },
      });
    default:
      return strictLocalize({
        id: "e13Mfi",
        defaultMessage: "Sign up",
        description: { text: "CTA button to sign up" },
      });
  }
};
